import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { HelmetProvider } from "react-helmet-async";
import { LanguageProvider } from "@/contexts/LanguageContext";
import { AuthProvider } from "@/contexts/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import { WhatsAppButton } from "@/components/WhatsAppButton";
import HomePage from "@/pages/HomePage";
import FleetPage from "@/pages/FleetPage";
import CarDetailPage from "@/pages/CarDetailPage";
import AboutPage from "@/pages/AboutPage";
import ContactPage from "@/pages/ContactPage";
import AdminLoginPage from "@/pages/admin/AdminLoginPage";
import { AdminDashboard, AdminCars, AdminBookings, AdminMessages, AdminUsers } from "@/pages/admin/AdminPages";
import { AdminPricing } from "@/pages/admin/AdminPricing";
// ...


// Scroll to top on route change
function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <HelmetProvider>
      <LanguageProvider>
        <AuthProvider>
          <BrowserRouter>
            <ScrollToTop />
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/fleet" element={<FleetPage />} />
              <Route path="/car/:id" element={<CarDetailPage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/admin/login" element={<AdminLoginPage />} />
              <Route path="/admin" element={<AdminDashboard />} />
              <Route path="/admin/cars" element={<AdminCars />} />
              <Route path="/admin/bookings" element={<AdminBookings />} />
              <Route path="/admin/messages" element={<AdminMessages />} />
              <Route path="/admin/users" element={<AdminUsers />} />
              <Route path="/admin/pricing" element={<AdminPricing />} />
            </Routes>
            <WhatsAppButton />
          </BrowserRouter>
          <Toaster position="top-right" />
        </AuthProvider>
      </LanguageProvider>
    </HelmetProvider>
  );
}

export default App;
